<!--
 * @Author: lwq
 * @Date: 2020-07-01 16:48:43
 * @LastEditTime: 2021-01-28 16:58:43
 * @LastEditors: Please set LastEditors
 * @Description: 日期选择器
 * @FilePath: \mrc-ess-base-frontend\src\components\mrc_ess_datePicker.vue
-->
<template>
  <!-- <mrc_ess_input
    v-if="disabled"
    v-model="computedDateFormatted"
    :label="label"
    :background-color="
      backgroundColor ? backgroundColor : disabled ? '' : '#f5f5f5'
    "
    :placeholder="placeholder ? placeholder : disabled ? ' ' : label"
    :error-messages="errMsg"
    color="primary"
    :rules="rules"
    :disabled="disabledTwo"
    :readonly="true"
  >
  </mrc_ess_input> -->
  <v-menu
    v-model="menu2"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :disabled="disabled"
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <mrc_ess_input
        v-model="computedDateFormatted"
        :label="label"
        color="primary"
        :append-icon="disabled ? '' : 'event'"
        :readonly="true"
        :rules="rules"
        :background-color="
          backgroundColor ? backgroundColor : disabled ? '#ffffff' : '#f5f5f5'
        "
        :disabled="disabledTwo"
        :placeholder="placeholder ? placeholder : disabled ? ' ' : label"
        :error-messages="errMsg"
        v-bind="attrs"
        v-on="on"
      >
      </mrc_ess_input>
    </template>
    <!---->
    <!--    :day-format="
                (date) => {
                  return $getDateTime(date, 'D');
                }
              " -->
    <v-date-picker
      color="primary"
      :day-format="
        (date) => {
          return getDateTime(date, 'D');
        }
      "
      :allowed-dates="allowedDate"
      v-model="computedDateFormatted"
      no-title
      :min="min"
      :max="max"
      :locale="lang"
      @input="menu2 = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
/**
 * @params label 标题
 * @params dateParse 传入的时间 时间戳格式
 * @params format 时间格式
 * @params disabled 是否禁用 只读状态
 * @params errMsg 手动错误提示
 * @params disabledTwo 禁用状态 比只读高一级  英文disabled被使用了
 * @event getTime 时间改变获取时间
 */
import moment from "moment";
export default {
  props: {
    backgroundColor: {},
    rules: {},
    allowedDates: {},
    afterDate: {
      //只能选择今天或者今天之后
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "日期",
    },
    dateParse: {
      // type: Number,
      // default: new Date().valueOf()
    },
    placeholder: {
      type: String,
    },
    format: {
      type: String,
      default: "YYYY-MM-DD",
    },
    min: {
      type: [String, Date],
      default: undefined,
    },
    max: {
      type: [String, Date],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    errMsg: {
      type: Array,
      default: () => [],
    },
    disabledTwo: {
      type: Boolean,
      default: false,
    },
  },
  data: (vm) => ({
    menu2: false,
  }),
  mounted() {},
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    computedDateFormatted: {
      get() {
        return this.dateParse ? this.formatDate(this.dateParse) : "";
      },
      set(val) {
        this.$emit("getTime", val);
      },
    },
  },
  model: {
    prop: "dateParse",
    event: "getTime",
  },
  watch: {
    menu2(val) {
      if (!val) {
        this.$emit("blur");
      }
    },
    dateParse: {
      handler(val) {
        if (val) {
          this.$emit("getTime", this.$moment(val));
        }
      },
      immediate: true,
    },
  },

  methods: {
    getDateTime(datetime, format) {
      if (datetime == "") return format == "HH:mm" ? "-- : --" : "";
      if (!datetime) return format == "HH:mm" ? "-- : --" : "";
      return moment(datetime).format(format);
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format(this.format);
    },
    allowedDate(val) {
      if (this.afterDate) {
        const date = new Date();
        let year = date.getFullYear(); // 获取完整的年份(4位,1970)
        let mon = date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)
        let da = date.getDate(); // 获取日(1-31)
        return (
          new Date(val).valueOf() >=
          new Date(year + "/" + mon + "/" + da).valueOf()
        );
      } else {
        if (Array.isArray(this.allowedDates)) {
          let isno = this.allowedDates.some((item1) => {
            return new Date(val).valueOf() == new Date(item1).valueOf();
          });
          if (!isno) return val;
        } else {
          return val;
        }
      }
    },
  },
};
</script>

<style scoped>
/deep/ .v-icon {
  margin-top: 7px;
  margin-right: 8px;
}
/deep/ .v-label {
  top: 2px !important;
}
/deep/ .v-input__append-inner {
  margin-right: 8px;
}
</style>
